function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

function time(date) {
    return ([[
        date.getFullYear(),
        padTo2Digits(date.getMonth() + 1),
        padTo2Digits(date.getDate()),
    ].join('/') +
    ' ' +
    padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
    ].join(':'));
}

function endTime(date) {
    return ([
        padTo2Digits(date.getHours()) === '00' ? '24' : padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
    ].join(':'));
}

export default function (value) {
    return value
    && value.start
    && value.end
    && value.start.getFullYear
    && value.end.getFullYear ?
        `${time(value.start)}-${endTime(value.end)}` : '';
}
